/**
 * InView Utility (single element)
 * Observes one element and fires callbacks when it enters/leaves viewport
 */
export default function inView(element, options = {}, callbacks = {}) {
    const {
        root = null,
        rootMargin = '0px',
        threshold = 0.1
    } = options;

    const {
        onEnter = () => {},
        onLeave = () => {}
    } = callbacks;

    // Support both selector string and direct element
    const target = typeof element === 'string'
        ? document.querySelector(element)
        : element;

    if (!target) return;

    const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
            onEnter(target, entry);
        } else {
            onLeave(target, entry);
        }
    }, { root, rootMargin, threshold });

    observer.observe(target);

    return observer;
}
